<template>
  <div class="event-title">
    <template v-if="emoji">
      <span class="emoji">{{ emoji }}</span>
    </template>
    <template v-else>
      <EventIcon />
    </template>
    <span class="name">{{ title || "Loading..." }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

import EventIcon from "@/components/icons/EventIcon.vue";
import * as inject from "@/components/inject";
import { useEmoji } from "@/composables/useEmoji";
import { useReleaser } from "@/ref";

export default defineComponent({
  name: "EventTitle",
  components: {
    EventIcon,
  },
  props: {
    eventId: {
      type: String,
      required: true,
    },
  },
  async setup(props) {
    const controller = inject.controller();
    const { title, emoji, updateText } = useEmoji();
    const eventId = ref(props.eventId);
    const releaser = useReleaser();
    const event = await releaser.add(controller.event.get(eventId.value));

    releaser.defer(
      watch(
        event,
        (event) => {
          if (!event) return;
          updateText(event.title || "Untitled");
        },
        { immediate: true }
      )
    );

    return {
      title,
      emoji,
    };
  },
});
</script>

<style lang="scss" scoped>
@use "@/styles/emoji.scss";

.event-title {
  display: flex;
  align-items: center;
  gap: 0px;
  width: 100%;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.selected {
    @include themed() {
      color: t($tertiary-50);
    }
  }
}
</style>
